import React, { SVGProps } from 'react'
const SvgCardRequestLabel = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        d="M18.696 10H5.804c-.581 0-1.054.344-1.054.767v6.466c0 .423.473.767 1.054.767h12.892c.581 0 1.054-.344 1.054-.767v-6.466c0-.423-.473-.767-1.054-.767Z"
      />
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M18.696 6.5H5.804c-.857 0-1.554.697-1.554 1.554v8.892c0 .857.697 1.554 1.554 1.554h12.892c.857 0 1.554-.697 1.554-1.554V8.054c0-.857-.697-1.554-1.554-1.554Zm-12.892 1h12.892c.305 0 .554.25.554.554v8.892c0 .305-.25.554-.554.554H5.804a.556.556 0 0 1-.554-.554V8.054c0-.305.25-.554.554-.554Z"
      />
      <path
        fill={props.fill || 'var(--color-cta)'}
        fillRule="nonzero"
        d="M18.696 6.5H5.804c-.857 0-1.554.697-1.554 1.554V11h16V8.054c0-.857-.697-1.554-1.554-1.554Zm0 1 .09.007a.556.556 0 0 1 .464.547V10h-14V8.054c0-.305.25-.554.554-.554h12.892ZM17 14.5a.5.5 0 0 1 .09.992L17 15.5h-2.75a.5.5 0 0 1-.09-.992l.09-.008H17Z"
      />
      <path fill="#FFF" d="M3.26 13h2v3h-2z" />
      <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
        <path d="M1.5 10.5a.5.5 0 0 1 .5.5c0 2.028.616 2.96 1.888 3.026l.15.003h4.795a.5.5 0 0 1 .09.992l-.09.008H4.038C2.028 15.03 1 13.6 1 11a.5.5 0 0 1 .5-.5Z" />
        <path d="M7.492 11.966a.5.5 0 0 1 .64.02l.062.066 1.7 2.169a.5.5 0 0 1 .052.535l-.052.082-1.7 2.17a.5.5 0 0 1-.837-.54l.05-.076 1.458-1.863-1.459-1.86a.5.5 0 0 1 .02-.64l.066-.063Z" />
      </g>
    </g>
  </svg>
)
export default SvgCardRequestLabel
